import { Observable } from 'rxjs';

export abstract class IFastAPIRepository {
}
